// Menu configuration – work items driven from workConfig.

import { WORK_ITEMS } from './workConfig';

export const MENU_TYPES = {
  MAIN: 'main',
  PORTFOLIO: 'portfolio',
};

export const CASE_STUDY_ROUTES = WORK_ITEMS.map((w) => w.path);

export const WORK_MENU_ITEMS = WORK_ITEMS.map(({ label, path }) => ({ label, path }));

export const MAIN_MENU_ITEMS = [
  { type: 'link', label: 'Home', path: '/' },
  { type: 'link', label: 'About', path: '/about' },
  { type: 'dropdown', label: 'Work', items: WORK_MENU_ITEMS },
  { type: 'link', label: 'Design process', path: '/how-i-work' },
];

export const getMenuType = (pathname) =>
  CASE_STUDY_ROUTES.includes(pathname) ? MENU_TYPES.PORTFOLIO : MENU_TYPES.MAIN;
